var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandsShake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.56 33.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#505050;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hands_shake") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.72.75a45.31,45.31,0,0,1-4,3.28c-1.09.17-6-2.13-7-2.38S14.92,4.54,14.18,5.73s2.18,4,5,3.64,7-1.85,8.18-.64c2,2,7.71,8,10.42,10.39,2.28,2,8.95-8.37,8.95-8.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.65,
    y1: 29.91,
    x2: 21.41,
    y2: 26.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.02,
    y1: 28.13,
    x2: 24.34,
    y2: 22.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.9,
    y1: 25.29,
    x2: 28.16,
    y2: 18.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.22,29.88a2,2,0,0,0,2.83,0l1.78-1.78a2,2,0,0,0-.32-2.87,2,2,0,0,0-2.87-.32A2,2,0,0,0,14.32,22a2,2,0,0,0-2.87-.32,2,2,0,0,0-.32-2.87,2,2,0,0,0-2.88-.32,2,2,0,0,0-.31-2.87,2,2,0,0,0-2.88-.32L3.29,17.12a2,2,0,0,0,0,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.86,29.07l.63.63L19,31.23c2.34,2.33,4.51.61,5.64-1.32A4.09,4.09,0,0,0,30,28.13c2.7,1.34,5.07-1.43,4.88-2.84a3.83,3.83,0,0,0,2.87-6.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.72,11.75,2.86,14a6.83,6.83,0,0,0,1.3,2.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.32,
    y1: 5.57,
    x2: 10.72,
    y2: 1.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.25,
    y1: 18.53,
    x2: 5.11,
    y2: 21.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.25,
    y1: 18.53,
    x2: 5.11,
    y2: 21.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.45,
    y1: 21.72,
    x2: 8.31,
    y2: 24.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.64,
    y1: 24.91,
    x2: 11.5,
    y2: 28.16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandsShake);
export default __webpack_public_path__ + "static/media/hands-shake.53b7e6a68e48821f96ae5bffb88dc22b.svg";
export { ForwardRef as ReactComponent };